import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { MainLayout } from '../../layouts';
import { baseUrl } from '../../config/baseUrl';
import { SignInAdmin, HomeAdmin, ConfigAdmin } from './components';
import withAuthentication from '../../routers/withAuthentication';
import { StyledWrapper } from './Admin.styled';

const Admin = (props) => {
  return (
    <MainLayout>
      <StyledWrapper>
        <Switch>
          <Route
            path={`${baseUrl}admin`}
            exact
            component={withAuthentication(HomeAdmin)}
          />
          <Route
            path={`${baseUrl}admin/sign-in`}
            exact
            component={SignInAdmin}
          />
          <Route
            path={`${baseUrl}admin/config`}
            exact
            component={withAuthentication(ConfigAdmin)}
          />
        </Switch>
      </StyledWrapper>
    </MainLayout>
  );
};

Admin.propTypes = {};

export default Admin;
